import InfoIcon from "@mui/icons-material/Info";
import { Fade, IconButton, Paper, Popper, Typography } from "@mui/material";
import { useState } from "react";

import {
    MAX_ATTACHMENT_FILE_SIZE_MB,
    MAX_UPLOADED_ATTACHMENTS_PER_LINE,
} from "../../../../constants/generalConstants";

export default function AttachmentInfoPopper() {
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);

    const handleInfoClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        setOpen((prev) => !prev);
    };

    return (
        <>
            <IconButton
                aria-label="fingerprint"
                color="success"
                onClick={handleInfoClick}
            >
                <InfoIcon />
            </IconButton>

            <Popper
                open={open}
                anchorEl={anchorEl}
                placement="bottom"
                transition
                sx={{ zIndex: 9999 }}
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper sx={{ p: 2, maxWidth: 300 }}>
                            <Typography
                                variant="h6"
                                component="h6"
                                sx={{ textDecoration: "underline" }}
                            >
                                Attachment Info
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                - You can upload a file of up to&nbsp;
                                {MAX_ATTACHMENT_FILE_SIZE_MB}MB
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                - Supported file types: PDF, DOCX, XLSX, MSG
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                - Upload up to&nbsp;
                                {MAX_UPLOADED_ATTACHMENTS_PER_LINE} files per
                                header and line
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                - Files are scanned for malware
                            </Typography>
                            <Typography
                                variant="caption"
                                display="block"
                                gutterBottom
                            >
                                Files detected with malware will be
                                automatically removed. Please ensure your files
                                are clean before uploading. If your file is
                                deleted, you will need to upload a new file.
                            </Typography>
                        </Paper>
                    </Fade>
                )}
            </Popper>
        </>
    );
}
